import {format_message, translate_message, message_locale}
    from '../../../includes/common/translated_message.js'

let memory_catalogue = null

function stored_catalogue() {
    const locale = message_locale(document.documentElement.lang || 'en-US')
    try {
        const catalogue = JSON.parse(localStorage.getItem('translation_messages'))
        if (catalogue?.locale === locale) return catalogue.messages
    } catch {
        // [CG] A blocked or corrupt cache must not discard a loaded catalogue.
    }
    return memory_catalogue?.locale === locale ? memory_catalogue.messages : null
}

function get_formatted_translated_word(key, parameters = {}, options = {}) {
    const messages = stored_catalogue() || {}
    const component = options.component
    let terms = component ? messages?.[component] : null
    if (!component) {
        terms = Object.values(messages || {}).find(group =>
            group && typeof group === 'object'
                && Object.prototype.hasOwnProperty.call(group, key))
    }
    return translate_message(key, parameters, terms, options)
}

async function load_catalogue() {
    if (stored_catalogue()) return true
    try {
        const response = await fetch('/api/v1/translations/website', {
            method: 'POST', credentials: 'same-origin',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                'X-Syngli-Platform': 'web'
            },
            body: 'languageID=-1&message_format=icu'
        })
        const catalogue = await response.json()
        if (!response.ok || !catalogue.messages
            || typeof catalogue.locale !== 'string') return false
        memory_catalogue = catalogue
        try {
            localStorage.setItem('translation_messages', JSON.stringify(catalogue))
        } catch {
            // [CG] The in-memory catalogue works when storage is unavailable.
        }
        return true
    } catch {
        return false
    }
}

// [CG] Consumers can await ready; failures retain the supplied English fallback.
window.SyngliI18n = {format: format_message, translate: translate_message,
    get: get_formatted_translated_word, load: load_catalogue,
    ready: load_catalogue()}
window.getFormattedTranslatedWord = get_formatted_translated_word
window.dispatchEvent(new Event('syngli:i18n-ready'))
